<script lang="ts">
	export let content: string = '';
</script>

<title>{content}</title>
<meta property="og:title" {content} />
<meta name="twitter:title" {content} />
